import { cn } from '@bem-react/classname';

export const cnIcon = cn('Icon');
